import { render, staticRenderFns } from "./CSidebarListItem.vue?vue&type=template&id=073b3c9a"
import script from "./CSidebarListItem.vue?vue&type=script&lang=js"
export * from "./CSidebarListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073b3c9a')) {
      api.createRecord('073b3c9a', component.options)
    } else {
      api.reload('073b3c9a', component.options)
    }
    module.hot.accept("./CSidebarListItem.vue?vue&type=template&id=073b3c9a", function () {
      api.rerender('073b3c9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CSidebarListItem.vue"
export default component.exports